import { Action } from '@ngrx/store';
import { MytitleError } from '../../../client/models/client.models';
import {
  ResetPasswordConfirmAction,
  ResetPasswordConfirmActions,
} from '../actions/reset-password-confirm.actions';
import { ResetPasswordAction, ResetPasswordActions } from '../actions/reset-password.actions';

export interface ResetPasswordState {
  resettingPassword: boolean;
  isResetPasswordEmailSent: boolean;
  resetPasswordError: MytitleError[];

  resettingPasswordConfirm: boolean;
  isReset: boolean;
  resetPasswordConfirmError: MytitleError[];
}

export const initialResetPasswordState: ResetPasswordState = {
  resettingPassword: false,
  isResetPasswordEmailSent: false,
  resetPasswordError: null,
  resettingPasswordConfirm: false,
  isReset: false,
  resetPasswordConfirmError: null,
};

export function resetPasswordReducer(
  state = initialResetPasswordState,
  generic: Action,
) {
  const action = generic as ResetPasswordAction
    | ResetPasswordConfirmAction;
  switch (action.type) {
    case ResetPasswordActions.RESET_PASSWORD: {
      return {
        ...state,
        resettingPassword: true,
        isResetPasswordEmailSent: false,
        resetPasswordError: null,
      };
    }
    case ResetPasswordActions.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        resettingPassword: false,
        isResetPasswordEmailSent: true,
        resetPasswordError: null,
      };
    }
    case ResetPasswordActions.RESET_PASSWORD_ERROR: {
      return {
        ...state,
        resettingPassword: false,
        isResetPasswordEmailSent: false,
        resetPasswordError: action.payload,
      };
    }

    case ResetPasswordConfirmActions.RESET_PASSWORD_CONFIRM: {
      return { ...state,
        resettingPasswordConfirm: true,
        isReset: false,
        resetPasswordConfirmError: null,
      };
    }
    case ResetPasswordConfirmActions.RESET_PASSWORD_CONFIRM_SUCCESS: {
      return {
        ...state,
        resettingPasswordConfirm: false,
        isReset: true,
        resetPasswordConfirmError: null,
      };
    }
    case ResetPasswordConfirmActions.RESET_PASSWORD_CONFIRM_ERROR: {
      return {
        ...state,
        resettingPasswordConfirm: false,
        isReset: false,
        resetPasswordConfirmError: action.payload,
      };
    }
  }
  return state;
}
